import { render, staticRenderFns } from "./MessageListSettingsModal.vue?vue&type=template&id=a507bd9a&scoped=true"
import script from "./MessageListSettingsModal.vue?vue&type=script&lang=js"
export * from "./MessageListSettingsModal.vue?vue&type=script&lang=js"
import style0 from "./MessageListSettingsModal.vue?vue&type=style&index=0&id=a507bd9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a507bd9a",
  null
  
)

export default component.exports